<template>
	<div class="status__container">
			<p>
				We are sorry. We are not able to retrieve this information at the moment.<br/>
				Please try again later.
			</p>
	</div>
</template>